import { Component, ReactNode } from 'react'
import * as loadScriptOnce from 'load-script-once'
import { removeElementById } from 'helpers/DOMHelpers'
import { YoutubeWindow } from 'interfaces/DOM'
import { captureException } from 'helpers/errorHelpers'

declare const window: YoutubeWindow
const YOUTUBE_SCRIPT_URL = 'https://www.youtube.com/iframe_api'
const YOUTUBE_READY_CALLBACK = 'onYouTubeIframeAPIReady'
// the following script is being appended by YOUTUBE_SCRIPT_URL script
const YOUTUBE_WIDGET_SCRIPT_ID = 'www-widgetapi-script'

type YoutubeAPILoaderProps = {
  render: (props: { isReady: boolean }) => ReactNode
}

type YoutubeAPILoaderState = {
  isReady: boolean
}

class YoutubeAPILoader extends Component<YoutubeAPILoaderProps, YoutubeAPILoaderState> {

  state = {
    isReady: false,
  }

  private YoutubeAPILoaderReady: Promise<void>
  private rejectLoadAPI?: () => void

  render () {
    return this.props.render({ isReady: this.state.isReady })
  }

  componentDidMount () {
    this.loadAPI()
  }

  componentWillUnmount () {
    this.rejectLoadAPI && this.rejectLoadAPI()
    removeElementById(YOUTUBE_WIDGET_SCRIPT_ID)
  }

  private loadAPI () {
    this.YoutubeAPILoaderReady = new Promise((resolve, reject) => {
      this.rejectLoadAPI = reject

      if (window.YT && window.YT.loaded) {
        resolve()
        return
      }

      window[YOUTUBE_READY_CALLBACK] = resolve
    })

    this.YoutubeAPILoaderReady.then(() => {
      this.setState({ isReady: true })
    })

    this.loadScript()
  }

  private loadScript () {
    loadScriptOnce(
      YOUTUBE_SCRIPT_URL,
      (error?: Error) => error && captureException(error)
    )
  }
}

export default YoutubeAPILoader
